module.exports = __webpack_public_path__ + "media/npc_dota_hero_visage.e711d391.webm";